export const searchId= (state) => state.search.id;
export const searchDep = (state) => state.search.dep;
export const searchArr = (state) => state.search.arr;
export const searchDepAt = (state) => state.search.depAt;
export const searchArrAt = (state) => state.search.arrAt;
export const searchDepCoor = (state) => state.search.depCoor;
export const searchArrCoor = (state) => state.search.arrCoor;
export const searchDepSuggestions = (state) => state.search.depSuggestions;
export const searchArrSuggestions = (state) => state.search.arrSuggestions;
export const searchPassengers = (state) => state.search.passengersIds;